import { render, staticRenderFns } from "./ErreurFtaForm.vue?vue&type=template&id=5963e876&scoped=true&lang=true&"
import script from "./ErreurFtaForm.vue?vue&type=script&lang=js&"
export * from "./ErreurFtaForm.vue?vue&type=script&lang=js&"
import style0 from "./ErreurFtaForm.vue?vue&type=style&index=0&id=5963e876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963e876",
  null
  
)

export default component.exports